module.exports = __webpack_public_path__ + "media/confirm.a62086ef.wav";